import { useEffect, useState } from 'react';
import api from '../services/api';

const metaInicial = {
  referencia: '',
  precio: null,
  precio_web_consultar: false,
  num_dormitorios: null,
  num_banos: null,
  m2_construidos: null,
};

/**
 * Carga fotos y metadatos básicos para la presentación / mando.
 * @param {string | null} propiedadId
 */
export function usePresentacionPropiedadData(propiedadId) {
  const [fotos, setFotos] = useState([]);
  const [videos, setVideos] = useState([]);
  const [meta, setMeta] = useState(metaInicial);
  const [cargando, setCargando] = useState(!!propiedadId);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!propiedadId) {
      setFotos([]);
      setVideos([]);
      setMeta(metaInicial);
      setCargando(false);
      setError('');
      return undefined;
    }
    let cancel = false;
    setCargando(true);
    setError('');
    (async () => {
      try {
        const [rFotos, rProp, rVideos] = await Promise.all([
          api.get(`/propiedades/${propiedadId}/fotos`),
          api.get(`/propiedades/${propiedadId}`),
          api.get(`/propiedades/${propiedadId}/videos`),
        ]);
        if (cancel) return;
        const rows = rFotos.data?.data || rFotos.data || [];
        setFotos(Array.isArray(rows) ? rows : []);
        const vrows = rVideos.data?.data || rVideos.data || [];
        setVideos(Array.isArray(vrows) ? vrows : []);
        const p = rProp.data?.data || rProp.data || {};
        setMeta({
          referencia: p.referencia || '',
          precio: p.precio_venta ?? p.precio ?? null,
          precio_web_consultar: !!p.precio_web_consultar,
          num_dormitorios: p.num_dormitorios ?? null,
          num_banos: p.num_banos ?? null,
          m2_construidos: p.m2_construidos ?? null,
        });
      } catch (e) {
        if (!cancel) setError(e.response?.data?.error || e.message || 'Error al cargar');
      } finally {
        if (!cancel) setCargando(false);
      }
    })();
    return () => {
      cancel = true;
    };
  }, [propiedadId]);

  return { fotos, videos, meta, cargando, error };
}
